import { useCallback } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import { TransformMode, useShrinkCuboid } from '@fabric-web/3d-viewer';
import { CuboidBase, CuboidState } from '../types';

export const useShrinkCurrentCuboid = <CuboidT extends CuboidBase>(
  cuboidState: CuboidState<CuboidT>
) => {
  const cuboids = useAtomValue(cuboidState.cuboids);
  const setCurrentCuboid = useSetAtom(cuboidState.currentCuboid);

  const setTransformMode = useSetAtom(cuboidState.cuboidTransformMode);

  const shrinkCuboid = useShrinkCuboid();

  const shrinkCurrentCuboid = useCallback(() => {
    if (!cuboids) return;
    let hasCuboidChanged = false;
    setCurrentCuboid((currentCuboid) => {
      if (currentCuboid) {
        const cuboidsArray = cuboids.map((value) => value);
        const result = shrinkCuboid(currentCuboid, cuboidsArray);
        if (!result.hasError && result.shrinkedCuboid) {
          hasCuboidChanged = true;
          return { ...currentCuboid, ...result.shrinkedCuboid };
        }
      }
      return currentCuboid;
    });
    if (hasCuboidChanged) {
      setTransformMode(TransformMode.View);
    }
  }, [setCurrentCuboid, setTransformMode, cuboids, shrinkCuboid]);

  return shrinkCurrentCuboid;
};
